import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class AssetClass extends ModelBase {
    static typeName = "AssetClass";

    public assetClassId: number = 0;

    @Rules.StringLength(30)
    @Rules.Required()
    public assetClassName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.assetClassName) {
            return "New asset class";
        } else {
            return this.assetClassName;
        }
    }
}